export const ENABLE_WABA_ID_DROPDOWN = 'ENABLE_WABA_ID_DROPDOWN';
export const DISABLE_WABA_ID_DROPDOWN = 'DISABLE_WABA_ID_DROPDOWN';
export const CHANGE_WABA_ID = 'CHANGE_WABA_ID';
export const TOGGLE_WABA_CHANGE_MODAL = 'TOGGLE_WABA_CHANGE_MODAL';
export const CHECK_WHATSAPP_PLAN_STATUS = 'CHECK_WHATSAPP_PLAN_STATUS';
export const DISABLE_WHATSAPP_PLAN_CHECK = 'DISABLE_WHATSAPP_PLAN_CHECK';
export const ADD_WABA_ID_OBJECT = 'ADD_WABA_ID_OBJECT';
export const ADD_PACKAGE_STATUS_DETAILS = 'ADD_PACKAGE_STATUS_DETAILS';

export function enableWabaIdDropdown(
	isLaunchPage?: boolean
): IEnableWabaIdDropdownActionType {
	return { type: ENABLE_WABA_ID_DROPDOWN, isLaunchPage: isLaunchPage };
}

export function disableWabaIdDropdown(
	isLaunchPage?: boolean
): IDisableWabaIdDropdownActionType {
	return { type: DISABLE_WABA_ID_DROPDOWN, isLaunchPage: isLaunchPage };
}

export function changeWabaIdDropdown(wabaId: string, version: string): IChangeWabaIdActionType {
	return { type: CHANGE_WABA_ID, wabaId: wabaId, version: version };
}

export function toggleWabaChangeModal(
	showWabaChangeModal: boolean,
	possibleWabaId?: string,
	waba_version?: number
): IWabaChangeModalActionType {
	return {
		type: TOGGLE_WABA_CHANGE_MODAL,
		showWabaChangeModal: showWabaChangeModal,
		possibleWabaId: possibleWabaId,
		possibleWabaVersion: waba_version,
	};
}

export function addWabaIdObject(
	wabaIdObject: Record<any, any>
): IAddWabaIdObjectActionType {
	return {
		type: ADD_WABA_ID_OBJECT,
		wabaIdObject: wabaIdObject,
	};
}

export function addPackageStatusDetails(
	whatsappPackageStatusDetails: Record<any, any>
): IAddPackageStatusDetailsActionType {
	return {
		type: ADD_PACKAGE_STATUS_DETAILS,
		whatsappPackageStatusDetails: whatsappPackageStatusDetails,
	};
}

interface IEnableWabaIdDropdownActionType {
	type: string;
	isLaunchPage: boolean | undefined;
}
interface IDisableWabaIdDropdownActionType {
	type: string;
	isLaunchPage: boolean | undefined;
}
interface IChangeWabaIdActionType {
	type: string;
	wabaId: string;
	version: string;
}
interface IWabaChangeModalActionType {
	type: string;
	showWabaChangeModal: boolean;
	possibleWabaId: string | undefined;
	possibleWabaVersion: number | undefined;
}
interface IAddWabaIdObjectActionType {
	type: string;
	wabaIdObject: Record<any, any>;
}
interface IAddPackageStatusDetailsActionType {
	type: string;
	whatsappPackageStatusDetails: Record<any, any>;
}
